import React, { Component, PureComponent, useContext, useState } from 'react';
import {NavLink, Link, Switch, Route, Redirect} from 'react-router-dom'
import {RootRouterContext} from '../../index.js'
import OurStoryPage from './OurStoryPage'
import Catering from './Catering'
import Taconight from './Taconight'
import Order from './Order'
import RestaurantMap from './ReataurantMap.js';
import Headers from './Headers'
// import AutoMenu from './AutoMenu'
import AutoMenu from '../../react/AutoMenu'
import CartBar from './CartBar'
import LocationsView from './LocationsView'
import FormJob from './FormJob'
import ScrollToTop from '../../react/ScrollToTop.js';
import BakeryVideo from "./BakeryVideo"
import FeaturedProducts from './FeaturedProducts.js';
import HamburgerMenu from './HamburgerMenu.js';
import './index.scss'
import './altStyleA.scss'
import './ThemeToggle/theme_night.scss'

export const customOrderAppPaths = ["/order", "/menu"]
export const StickyTopBar = () => { return null }

export const locations = [
  {shopId: "taronglendale",     basePath: "/glendale", cssGlobalPrefix: 'taron'},
  {shopId: "kluckin",     basePath: "/hollywood", cssGlobalPrefix: 'kokorollburbank'},
  {shopId: "kluckinla",    basePath: "/la", cssGlobalPrefix: 'kokorollburbank'},
  
  // {shopId: "kokorollhollywood",    basePath: "/hollywood", cssGlobalPrefix: 'kokorollburbank'},
]

export const pages = [
  {path: "/order", label: "Order"},
  {path: "/menu", label: "Menu"},
  // {path: '/jobs', label: 'Jobs', component: ()=> <FormJob></FormJob> },

  {path: "/hqusers/storeRedirect/:anything", label: "Catering", hideFromNav: true, component: () => <Redirect to="/"></Redirect>},
  // {path: "/taco-night", label: "Event", component: Taconight},
  // {path: "/order-altadena", label: "Menu", component: OrderAltadena},
]

export function SiteNav ({shopId}) {

    const {rootHistory} = useContext(RootRouterContext)


    return (
      <>
      <CartBar shopId={shopId}></CartBar>
    <nav role="navigation" aria-label="navigation">
    
   
  </nav>
  </>
  )
}



export function MultilocationHome () {

  const theme = "light"
  const heroLogoUrl = (theme !== 'dark') ?
    "https://afag.imgix.net/the-kluckin-chicken/kluckin-chicken-logo-1.png?w=500&auto=format" :
    "https://afag.imgix.net/the-kluckin-chicken/kluckin-chicken-logo-1.png?w=500&auto=format"

  return(
    <div className={"site-content taron" + " " + theme}>
      <Headers></Headers>

      <div role="navigation" aria-label="primary" className="cart-wrapper">
      
            <div className="cart minimized">
              <div className="home-link-wrapper">
                <h2>
                  <Link to="/" 
                  aria-label={"Taron Bakery"}
                  className="home-link" aria-label="home page">
                         <img
                          className="nav-bar-logo"
                          src={"https://afag.imgix.net/taron-bakery/logo-center.png?w=1000&auto=format"}
                          alt="Taron Bakery"
                        />
                    {/* <LogoBar
                    alt={shop.name && shop.name.en}
                    shopId={shopId} theme={(theme === 'dark') ? 'light' : 'dark'}></LogoBar> */}
                    {/* <span className="text-logo">{!logo && shop.name && shop.name.en}</span> */}
                  </Link>
                </h2>
      
              </div>
      
      
      
              <div className="site-nav-bar" aria-labelledby="shopping-cart-link">
                {/* {showCashback ? <span className="cashback-amount">
                  ${cashback / 100}
                </span> : null} */}
                  <Link className="nav-bar-link secondary" to="/our-story" aria-label="our-story">
                    Our Story
                  </Link>
                  <Link className="nav-bar-link secondary" to="/catering" aria-label="catering">
                    Catering
                  </Link>
                  <a className="nav-bar-link call-to-action" href="/glendale/order" aria-label="order">
                    Order
                  </a>


                 <HamburgerMenu></HamburgerMenu>
           
                  

                {/* <Link
                id="shopping-cart-link"
                  aria-label="shopping cart"
                  aria-label="shopping cart"
                  to={{pathname: "/checkout", state: {fromMini: true}}}
                  className="checkout-button button">Order Online</Link> */}
              </div>
      
      
      
            </div>
          </div>
    
      <div className="home-page-hero" role="banner" aria-labelledby="hero-link">
        <div>
          <Link to="/" aria-label="Kluckin Chicken" id="hero-link" className="hero-link">
          
              {/* <LogoHero
                theme={theme}
                ></LogoHero> */}
            {/* <img
              className="hero-logo"
               src={heroLogoUrl} alt={"Kluckin Chicken"}/> */}
          </Link>
        </div>
      </div>



      {/* <div className="promo">
        <div style={{
          maxWidth: "400px"
        }} className="figure">

        <img style={{width: "100%"}} src="https://afag.imgix.net/the-kluckin-chicken/kluckin-ten.png?w=1200&auto=format" alt="" />
        </div>
      </div> */}
  
      <Switch>
        <Route path="/order" component={Order} />
        <Route path="/online-ordering" component={Order} />
        <Route path="/about-us" component={Order} />
        <Route path="/menu" component={Order} />
        <Route path="/locations" component={Order} />
        <Route path="/catering" component={Catering} />
        <Route path="/taco-night" component={Taconight} />
        <Route path="/" exact component={MultiHeader}></Route>
        <Route path="/hqusers/storeRedirect/:anything" render={() => {
          return(<Redirect to="/"></Redirect>)
        }}></Route>
        {/* <MultiHeader></MultiHeader> */}
      </Switch>
    </div>
  )
}

function ContactPage () {
  return(
    <div className="contact-page">
      <div className="contact-page-content">
        <h2>How Are We Doing?</h2>
        <p>
        We value your feedback at Kluckin Chicken. If you have recently visited one of our locations, please take a moment to call our corporate office <a href="tel:+19195823222">818-582-3222</a> and let us know how we did. Your input helps us improve our service and the overall customer experience. Thank you for choosing Kluckin Chicken!
        </p>
      </div>


    </div>
  )
}

class MultiHeader extends PureComponent {
  render() {
    return (
      <div className="landing-page-wrapper" >
        <div className="home-grid">


         {/* <BakeryVideo></BakeryVideo> */}

         <div className="hero-section">
          <img src="https://afag.imgix.net/taron-bakery/logo.png?w=1000&auto=format" alt="" />
         </div>


         <h2 className="header-text">
          Welcome to Taron Bakery
         </h2>


         <p className="body-text">
         Step into the warmth of tradition with every bite. From our legendary lahmajune to crave-worthy spicy cheese boreks, everything is handmade daily using time-honored recipes and baked fresh in our ovens. With three family-run locations across LA, Taron Bakery brings the heart of Armenian hospitality to your neighborhood – one pastry at a time.
         </p>


         <h2 className="header-text">
          Featured Items
         </h2>

          <FeaturedProducts></FeaturedProducts>

        <h2 className="header-text">
          Our Locations
        </h2>
        <LocationsView></LocationsView>

          
        </div>

      </div>
    );
  }
}




export class Header extends PureComponent {
  render() {
    // console.log('header props:', this.props)
    const shopId = this.props.shopId
    const basePath = this.props.basePath

    if (basePath === '/la') {
      return(
        <div className="location-page">
        
        <div
        style={{
          textAlign: "center",
          margin: "2em 1em 50em 1em" 
        }}
         className="hiring">
          <h1>We Moved</h1>
          <p>Kluckin Chicken La Crescenta @ 3747 Foothill Blvd<br/>has moved to a new location (3miles away)</p>
          <a className="order-button hire" href="/sunland">
            Sunland Location →</a>
       </div>
        
        </div>
      )
    }

    const backgroundULRBase = (basePath === '/shermanoaks') ?
    "https://afag.imgix.net/the-kluckin-chicken/nuggets.jpeg?w=1200&auto=format"
    : "https://afag.imgix.net/the-kluckin-chicken/kluckin-ten.png?w=1200&auto=format"
    return (
      <div className="location-page">
      
        <div className="top-banner" style={{
          // backgroundImage: `url(${backgroundULRBase})`,
          // backgroundColor: "rgb(238,143,33)",
          // background:  `url(${backgroundULRBase}), linear-gradient(180deg, rgba(238,143,33,1) 0%, rgba(226,90,39,1) 100%)`,
          // backgroundSize: "contain"
          // background: "black"
        }}> 

        </div>

       

        {/* <div className="special">
              <a href="/public/kluckinall/kluckin-chicken-print-coupon.pdf">
                <img 
                style={{
                  width: "100%",
                  maxWidth: "550px",
                  display: "block",
                  margin: "1em auto",
                }}
                src="https://afag.imgix.net/the-kluckin-chicken/promo-banner-1.png?w=900&auto=format" alt="" />
              </a>
            </div> */}

      

           {/* {(shopId === 'kluckinva') && <div className="hiring">
              <Link className="order-button hire" to="/jobs">We're Hiring →</Link>
            </div>} */}
      <h2 id="order" style={{visibility: 'hidden', height: "0px", margin: "0", padding: "0"}}>Order Online</h2>

        <div className="ordering-menu">
          <AutoMenu
            altStyleA
            width={500}></AutoMenu>
        </div>
      </div>
    );
  }
}



let locationsMetadata = [
  {
    id: 'taronglendale',
    // disabled: true, openingDate: "visit/call to order",
    label: "Glendale",
    className: 'night',
    address: ["1117 S Glendale Ave", "Glendale, CA 91205"],
    phone: "818-553-1883",
    phoneLink: "+18185531883",
    orderLink: "/glendale",
    hours: [
      { day: 'Mon-Sat', hours: '7:30am-7pm' },
      { day: 'Sun', hours: '7:30am-4:30pm' },

    ]},
  {
    id: 'taronnoho',
    label: "North Hollywood",
    // special: "We Moved!",
    address: ["6248 Santa Monica Blvd", "Los Angeles, CA 90038"],
    phone: "323-380-5940",
    phoneLink: "+13233805940",
    orderLink: "/melrose",
    // external: true,
    hours: [
      { day: 'Mon-Sun', hours: '11am-3am' },

    ]},
    {
      id: 'taronhollywood',
      // disabled: true, openingDate: "visit/call to order",
      label: "Hollywood",
      className: 'night',
      address: ["18125 Saticoy St Unit A", "Reseda, CA 91335"],
      phone: "818-600-8367",
      phoneLink: "+18186008367",
      orderLink: "/reseda",
      hours: [
        { day: 'Mon-Sun', hours: '11am-2am' },

      ]},

]

export function subMenuFilter (subMenu) {
  const tag = subMenu.tag
  if (tag === 'order') {
    return true
  }

  return true
}
